"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_WRITE_PERMISSION = exports.PORTAL_SUSPENDED = void 0;
var PORTAL_SUSPENDED = 'PORTAL_SUSPENDED';
exports.PORTAL_SUSPENDED = PORTAL_SUSPENDED;
var USER_WRITE_PERMISSION = 'USER_WRITE_PERMISSION';
exports.USER_WRITE_PERMISSION = USER_WRITE_PERMISSION;